import type { ComponentProps } from "react";
import type { Table } from "@narmi/design_system";

export const COL_LAYOUT = {
  s: "52px 1fr 1fr 1fr 1fr 227px",
  m: "52px 1fr 1fr 1fr 1fr 227px",
  l: "52px 1fr 1fr 1fr 1fr 227px",
};

export const COL_VISIBILITY: ComponentProps<typeof Table>["colVisibility"] = [
  "*", // checkbox
  "*", // name
  "*", // account
  "*", // routing
  "*", // type
  "*", // action
];

// Without the Recipient permission, the checkbox and action columns are hidden.
export const READ_ONLY_COL_LAYOUT = {
  s: "1fr 1fr 1fr 1fr",
  m: "1fr 1fr 1fr 1fr",
  l: "1fr 1fr 1fr 1fr",
};

export const READ_ONLY_COL_VISIBILITY: ComponentProps<
  typeof Table
>["colVisibility"] = ["*", "*", "*", "*"];

export const CATEGORY_KEYS = [
  "name",
  "account_number",
  "routing_number",
  "account_type",
];
